<script>
import { defineAsyncComponent } from 'vue';
import { useForm } from 'vee-validate';
import PhoenixForm from '@phoenix/mixins/components/form/PhoenixForm';
import { PhxBox } from '@sg/src/View/Components/Atoms/Box';
import { PhxsgButton } from '@sg/src/View/Components/Atoms/Button';

export default {
  components: {
    PhxBox,
    PhxsgButton,
    ChinesePIPL: defineAsyncComponent(() => import('@maison/components/form/fields/ChinesePIPL')),
    KoreanGDPR: defineAsyncComponent(() => import('@maison/components/form/KoreanGDPR')),
  },

  mixins: [PhoenixForm],

  props: {
    customSubmitButtonClasses: {
      type: String,
      default: null,
    },
  },

  setup() {
    const { setValues, validate } = useForm();
    return { setValues, validate };
  },

  computed: {
    submitButtonClasses() {
      return this.customSubmitButtonClasses || 'btn btn--primary btn--plain';
    },
  },
};
</script>

<template>
  <form ref="form" @submit.prevent="submit">
    <div v-if="isLoading" class="center center--and-text">
      <div class="loader loader--dark">
        <div class="loader__inner"></div>
      </div>
    </div>

    <div v-else class="stack stack--spacing-4">
      <slot :should-display-newsletter="!shouldDisplayKoreanGDPR" />

      <korean-g-d-p-r v-if="shouldDisplayKoreanGDPR" :form-type="koreanFormType" @change="onKoreanGDPRChange" />

      <chinese-p-i-p-l
        v-if="shouldDisplayPIPLConsentCheckboxes"
        :value="chinesePiplConsents"
        :custom-inner-class="customConsentInnerClass"
        :custom-outer-class="customConsentOuterClass"
        :privacy-link="privacyLink"
        :form-type="formType"
        @on-chinese-pipl-consent-change="onChinesePiplConsentChange"
      />

      <phx-box v-if="!showErrorsInToast && mainErrors" solid spacing="2" class="alert alert--error">
        {{ mainErrors }}</phx-box
      >

      <div v-if="shouldShowFormActions" class="form-actions">
        <slot name="form-actions" :is-disabled="isDisabled" />

        <PhxsgButton
          v-if="shouldDisplaySubmitButton"
          ref="submitButton"
          :disabled="isDisabled"
          type="submit"
          :class="submitButtonClasses"
          data-cy="form-submit-btn"
        >
          {{ submitText }}
        </PhxsgButton>

        <PhxsgButton
          v-if="shouldDisplayCancelButton"
          ref="cancelButton"
          :disabled="isDisabled"
          variant="plain"
          color="secondary"
          data-cy="form-cancel-btn"
          @click.prevent="onCancelCallback"
        >
          {{ cancelText }}
        </PhxsgButton>

        <div v-if="shouldDisplayTermsLink" class="form-actions__terms rich-text" v-html="termsLink" />
      </div>
    </div>
  </form>
</template>
